fx.service( class LayoutsGenerator extends fx.EventDispatcher {

    constructor(model)
    {
        super();

        this.model = model.creationModel;
        
        this._pageWidth = this.model.creation.pageWidth;
        this._pageHeight = this.model.creation.pageHeight;

        this._pageMargin = 20;
        this._pictureMargin = 4;

        this._sortAreasHandler = this._sortAreas.bind(this);
        this._layouts = {};

       
    }

    getLayouts(photos)
    {
        if (this._hasLayouts(photos))
            return this._getStoredLayouts(photos);

        let photosComponents = this._getPhotosComponents(photos);

        let page = {x:0, y : 0, width : this._pageWidth, height : this._pageHeight};

        let dimension = 1;
        while(dimension * dimension < photos.length)
            dimension++;

        let combinations = this._findSumPermutations(dimension, photos.length);
        let layouts = [];

        let gridsH = this._getGridsHorizontal(photosComponents, dimension, combinations);
        let gridsV = this._getGridsVertical(photosComponents, dimension, combinations);
            
        layouts = layouts.concat( this._getLayoutsHorizontal(gridsH, page) );
        layouts = layouts.concat( this._getLayoutsVertical(gridsV, page) );
        
        layouts = this._filterLayouts( layouts, page, photos);

        layouts = this._improveLayouts(layouts);

        this._storeLayouts(photos, layouts);

        return layouts;
    }

    _hasLayouts(photos)
    {
        return this._layouts[this.getCode(photos)]
    }

    _storeLayouts(photos, layouts)
    {        
        this._layouts[this.getCode(photos)] = layouts;
    }

    _getStoredLayouts(photos)
    {
        return this._layouts[this.getCode(photos)];
    }

    getCode(elements)
    {
        let code = "";
        for (let i = 0; i < elements.length; i++)
            //code += elements[i].width > elements[i].height ? "h" : "v";
            code += elements[i].width + "x" + elements[i].height + ( (i+1 < elements.length) ? "|" : "");
        return code;
    }


    _getGridsHorizontal(photos, dimension, combinations)
    {
        if (photos.length == 2)
            combinations.push([[2]]);
        
        let grids = [];
        for(let i = 0; i < combinations.length; i++)
        {
            let combination= combinations[i];
            let index = 0;
            
            let grid = [];
            for (let k = 0; k < dimension; k++)
            {
                grid[k] = [];
                for (let j = 0; j < combination[k]; j++)
                {
                    let photo =  photos.getItemAt(index++);
                    grid[k].push( { photo : photo, width :  photo.width, height : photo.height } );

                     if (index > photos.length)
                        break;
                }

                if (index > photos.length)
                    break;
            }

            // create layout
            grids.push(grid);
        }

        return grids;
    }

    _getGridsVertical(photos, dimension, combinations)
    {
        if (photos.length == 2)
            combinations.push([[2]]);
        
        let grids = [];
        for(let i = 0; i < combinations.length; i++)
        {
            let combination= combinations[i];
            let index = 0;
            
            let grid = [];
            for (let k = 0; k < dimension; k++)
            {
                for (let j = 0; j < combination[k]; j++)
                {
                    if (!grid[k])
                        grid[k] = [];

                    let photo =  photos.getItemAt(index++);
                    grid[k].push( { photo : photo, width :  photo.width, height : photo.height } );

                     if (index > photos.length)
                        break;
                }

                if (index > photos.length)
                    break;
            }

            // create layout
            grids.push(grid);
        }

        return grids;
    }

    _getLayoutsVertical(grids, page)
    {
        let layouts = [];
        for(let i = 0; i < grids.length; i++)
        {
            let layout = this._createLayoutVertical( grids[i], page);
            layouts.push( layout );
        }

        return layouts;
    }
    _getLayoutsHorizontal(grids, page)
    {
        let layouts = [];
        for(let i = 0; i < grids.length; i++)
        {
            let layout = this._createLayoutHorizontal(grids[i], page);
            layouts.push( layout );
        }

        return layouts;
    }

    _createLayoutVertical(grid, page)
    {
        // calculate minRowHeight
        for(let i = 0; i < grid.length; i++)
        {
            let col = grid[i];
            for(let j = 0; j < col.length; j++)
            {   
                let cell = col[j];
                
                col.minWidth = col.minWidth ? Math.min(col.minWidth, cell.width) : cell.width;
            }            
        }

        // resize width of all picture that doesn't match row.minHeight
        // and calculate maxHeight
        let maxHeight = 0;
        for(let i = 0; i < grid.length; i++)
        {
            let col = grid[i];
            col.height = 0;
            for(let j = 0; j < col.length; j++)
            {   
                let cell = col[j];

                if (cell.width > col.minWidth)
                {
                    cell.height = cell.height * col.minWidth / cell.width;
                    cell.width = col.minWidth;
                }
                col.height += cell.height;
            }
            maxHeight = Math.max(maxHeight, col.height);
        }

        // resize height of pictures in row of less than maxHeight
        for(let i = 0; i < grid.length; i++)
        {
            let col = grid[i];
            if (col.height < maxHeight)     
            {  
                col.minWidth = undefined;
                let scale = maxHeight / col.height;

                for(let j = 0; j < col.length; j++)
                {   
                    let cell = col[j];
                    

                    cell.width =  cell.width*scale;
                    cell.height =  cell.height*scale;

                    // calculate again minHeight, used in positionning
                    col.minWidth = col.minWidth ? Math.min(col.minWidth, cell.width) : cell.width;
                }
            }
        }

        // position pictures
        let xPos = 0;
        for(let i = 0; i < grid.length; i++)
        {
            let yPos= 0;
            let col = grid[i];
            for(let j = 0; j < col.length; j++)
            {
                let cell = col[j];
                

                cell.y = yPos;
                cell.x = xPos;

                yPos += cell.height;
            }

            if (col.minWidth)
                xPos += col.minWidth;
        }


        //grid = this._scaleGrid(grid, page, true);
        //return grid.flat();
        grid = this._scaleGrid(grid, page);
        
        //--- 2 : add margins
        let xMargin, yMargin = 0;
        maxHeight = 0;
        for(let i = 0; i < grid.length; i++)
        {
            let col = grid[i];
            col.height = 0;
            yMargin = 0;
            for(let j = 0; j < col.length; j++)
            {
                let cell = col[j];
                if (j > 0)
                    yMargin += this._pictureMargin;

                cell.x += xMargin;
                cell.y += yMargin;

                col.height = Math.max(col.height, cell.y + cell.height);
            }
            xMargin += this._pictureMargin;
            maxHeight = Math.max(maxHeight, col.height);
        }

        //--- 3 : scale components
        // resize width of pictures in row of less than maxWidth
        for(let i = 0; i < grid.length; i++)
        {
            let col = grid[i];
            
            col.minWidth = undefined;
            let scale = (col.height < maxHeight) ? (maxHeight / col.height) : 1;

            for(let j = 0; j < col.length; j++)
            {   
                let cell = col[j];
                cell.width =  cell.width*scale;
                cell.height =  cell.height*scale;

                // calculate again minHeight, used in positionning
                col.minWidth =col.minWidth ? Math.min(col.minWidth, cell.width) : cell.width;
            }
        
        }

        //--- 4 : position components and add margins
        xPos = 0;
        xMargin = 0;
        yMargin = 0;
        for(let i = 0; i < grid.length; i++)
        {
            let yPos = 0;
            let col = grid[i];
            yMargin = 0;
            for(let j = 0; j < col.length; j++)
            {
                let cell = col[j];

                if (j > 0)
                    yMargin += this._pictureMargin;

                cell.y = yPos + yMargin;
                cell.x = xPos + xMargin;

                yPos += cell.height;
            }

            xMargin += this._pictureMargin;

            if (col.minWidth)
                xPos += col.minWidth;
        }


        grid = this._scaleGrid(grid, page, true);
        
        return grid.flat();
    }

    _createLayoutHorizontal(grid, page)
    {
        // calculate minRowHeight
        for(let i = 0; i < grid.length; i++)
        {
            let row = grid[i];
            for(let j = 0; j < row.length; j++)
            {   
                let cell = row[j];
                row.minHeight = row.minHeight ? Math.min(row.minHeight, cell.height) : cell.height;
            }            
        }

        // resize height of all picture that doesn't match row.minHeight
        // and calculate maxWidth
        let maxWidth = 0;
        for(let i = 0; i < grid.length; i++)
        {
            let row = grid[i];
            row.width = 0;
            for(let j = 0; j < row.length; j++)
            {   
                let cell = row[j];
                if (cell.height > row.minHeight)
                {
                    cell.width = cell.width * row.minHeight / cell.height;
                    cell.height = row.minHeight;
                }
                row.width += cell.width;
            }
            maxWidth = Math.max(maxWidth, row.width);
        }

        // resize width of pictures in row of less than maxWidth
        for(let i = 0; i < grid.length; i++)
        {
            let row = grid[i];
            if (row.width < maxWidth)     
            {  
                row.minHeight = undefined;
                let scale = maxWidth / row.width;

                for(let j = 0; j < row.length; j++)
                {   
                    let cell = row[j];
                    cell.width =  cell.width*scale;
                    cell.height =  cell.height*scale;

                    // calculate again minHeight, used in positionning
                    row.minHeight = row.minHeight ? Math.min(row.minHeight, cell.height) : cell.height;
                }
            }
        }

        // position pictures
        let yPos = 0;
        for(let i = 0; i < grid.length; i++)
        {
            let xPos = 0;
            let row = grid[i];
            for(let j = 0; j < row.length; j++)
            {
                let cell = row[j];
                cell.y = yPos;
                cell.x = xPos;

                xPos += cell.width;
            }

            if (row.minHeight)
                yPos += row.minHeight;
        }


        grid = this._scaleGrid(grid, page, false);

        //--- 2 : add margins
        let xMargin, yMargin = 0;
        maxWidth = 0;
        for(let i = 0; i < grid.length; i++)
        {
            let row = grid[i];
            row.width = 0;
            xMargin = 0;
            for(let j = 0; j < row.length; j++)
            {
                let cell = row[j];
                if (j > 0)
                    xMargin += this._pictureMargin;

                cell.x += xMargin;
                cell.y += yMargin;

                row.width = Math.max(row.width, cell.x + cell.width);
            }
            yMargin += this._pictureMargin;
            maxWidth = Math.max(maxWidth, row.width);
        }

        //--- 3 : scale components
         // resize width of pictures in row of less than maxWidth
         for(let i = 0; i < grid.length; i++)
        {
            let row = grid[i];
            
            row.minHeight = undefined;
            let scale = (row.width < maxWidth) ? (maxWidth / row.width) : 1;

            for(let j = 0; j < row.length; j++)
            {   
                let cell = row[j];
                cell.width =  cell.width*scale;
                cell.height =  cell.height*scale;

                // calculate again minHeight, used in positionning
                row.minHeight = row.minHeight ? Math.min(row.minHeight, cell.height) : cell.height;
            }
        
        }

        //--- 4 : position components and add margins
        yPos = 0;
        xMargin;
        yMargin = 0;
        for(let i = 0; i < grid.length; i++)
        {
            let xPos = 0;
            let row = grid[i];
            xMargin = 0;
            for(let j = 0; j < row.length; j++)
            {
                let cell = row[j];

                if (j > 0)
                    xMargin += this._pictureMargin;

                cell.y = yPos + yMargin;
                cell.x = xPos + xMargin;

                xPos += cell.width;
            }

            yMargin += this._pictureMargin;

            if (row.minHeight)
                yPos += row.minHeight;
        }


        grid = this._scaleGrid(grid, page, true);
        
        return grid.flat();
    }

    _scaleGrid(grid, page, center)
    {
        let scale = 1;
        let xOffset = 0;
        let yOffset = 0;
        let area = this._calculateBoundingBox(grid.flat());

        scale = (area.width > area.height) ?  (page.width - this._pageMargin) / area.width : (page.height - this._pageMargin) / area.height;
        
        if (area.height * scale > page.height)
            scale = (page.height - this._pageMargin) / area.height;

        if (area.width * scale > page.width)
            scale = (page.width - this._pageMargin) / area.width;
        
        if (center)            
        {
            xOffset = - area.x*scale + (page.width - area.width*scale) / 2;
            yOffset = - area.y*scale + (page.height - area.height*scale) / 2;
        }

        for(let i = 0; i < grid.length; i++)
        {
            let row = grid[i];
            for(let j = 0; j < row.length; j++)
            {
                let cell = row[j];

                cell.width *= scale;
                cell.height *= scale;
                cell.x = (cell.x * scale) + xOffset;
                cell.y = (cell.y * scale) + yOffset;
            }
        }

        return grid;
    }

    _findSumPermutations(dimension, max) {
        const results = [];
      
        function generatePermutations(currentPermutation = []) {
          if (currentPermutation.length === dimension) {
            if (currentPermutation.reduce((sum, num) => sum + num, 0) === max) {
              results.push([...currentPermutation]);
            }
            return;
          }
      
          for (let i = 1; i <=max; i++) {
            currentPermutation.push(i);
            generatePermutations(currentPermutation);
            currentPermutation.pop();
          }
        }
      
        generatePermutations();
        return results;
      }
 
    
    // -------------------------------------------------------------- //

    _filterLayouts( layouts, page, photos)
    {
        let uniqueLayouts = [];
        const seenLayouts = new Set();
    
        layouts.forEach(layout => {

            layout = layout.sort( (a, b) => a.x - b.x || a.y - b.y );

            let key = "";
            layout.forEach( rect => {
                key += `${Math.round(rect.x)}|${Math.round(rect.y)}|${Math.round(rect.width)}|${Math.round(rect.height)}|`;
            });

            if (!seenLayouts.has(key)) {
                seenLayouts.add(key);
                uniqueLayouts.push(layout);
            }
        });

       /*let filtered = [];
       for(let i = 0; i < uniqueLayouts.length; i++)
        {
            let layout = uniqueLayouts[i];
           
            let area = this._calculateBoundingBox(layout);

            // keep the ones that area closer to page area
            layout.rate = this._compareAspectRatios(area, page);

            filtered.push(layout);
        }*/
     
        uniqueLayouts = uniqueLayouts.sort( this._sortAreasHandler );

        //uniqueLayouts = uniqueLayouts.sort((a, b) => b.rate - a.rate);
        //uniqueLayouts = uniqueLayouts.sort((a,b) => b.width*b.height - a.width*a.height);
        
        if (uniqueLayouts.length > 30 && photos.length > 2)
            uniqueLayouts.splice(30, uniqueLayouts.length);
        
        return uniqueLayouts;
    }

    _sortAreas(a,b)
    {
        let areaA = this._calculateBoundingBox(a);
        let areaB = this._calculateBoundingBox(b);
       return (areaB.width * areaB.height) -  (areaA.width * areaA.height);
    }

    _compareAspectRatios(rect1, rect2) {
        // Calculate aspect ratios
        const aspectRatio1 = rect1.width / rect1.height;
        const aspectRatio2 = rect2.width / rect2.height;
      
        // Ensure the larger aspect ratio is always divided by the smaller one
        const ratio = aspectRatio1 > aspectRatio2 
          ? aspectRatio1 / aspectRatio2 
          : aspectRatio2 / aspectRatio1;
      
        // Convert the ratio to a 0-1 scale
        // We use 1/ratio because we want 1 when the ratios are the same (ratio = 1)
        // and approach 0 as they become more different (ratio approaches infinity)
        const similarity = 1 / ratio;
      
        return similarity;
      }

    _getPhotosComponents(photos)
    {
        // ratio photos IPhone : horizontal => 4032 / 3024, vertical => 3024 / 4032
        let photosComponents = [];
        let baseWidth = (this._pageWidth / photos.length);
        let baseHeight = (this._pageWidth / photos.length);
        let sizeRatio = this._pageWidth / this._pageWidth;
        let horizontalRatio, verticalRatio;
        if (sizeRatio > 0.9 && sizeRatio < 1.1)
        {
            horizontalRatio= 4032 / 3024;
            verticalRatio = 3024 / 4032;
        }
        else
        if (sizeRatio > 1)
        {
            horizontalRatio= this._pageWidth / this._pageWidth;
            verticalRatio = this._pageWidth / this._pageWidth;
        }
        else
        {
            horizontalRatio= this._pageWidth / this._pageWidth;
            verticalRatio = this._pageWidth / this._pageWidth;
        }

        for (let i = 0; i < photos.length; i++)
        {
            let photo = photos[i];
            /*let horizontal = (photo.width > photo.height);
            
            let photoWidth; 
            let photoHeight; 

            if (horizontal)
            {
                photoWidth = baseWidth;
                photoHeight = photoWidth * verticalRatio;
            }
            else
            {
                photoHeight = baseHeight;
                photoWidth = photoHeight / horizontalRatio;
            }

            photosComponents.push({photo : photo, width : photoWidth, height : photoHeight});   */
            photosComponents.push({photo : photo, width : photo.width, height : photo.height});    
        }


        return photosComponents;
    }

    
    _improveLayouts(layouts)
    {
        // create layouts from matching combinations
        // center in page 
        // position each photo 

        let improvedLayouts = [];
        for(let i = 0; i < layouts.length; i++)
        {
            let layout = layouts[i];


            let components = [];
            for(let j = 0; j < layout.length; j++)
            {   
                components.push( new models.ThemeLayoutComponent( {
                                                                        component_type : "photo",
                                                                        x : layout[j].x,
                                                                        y : layout[j].y,
                                                                        width : layout[j].width,
                                                                        height : layout[j].height,
                                                                        width_inner : 0,
                                                                        height_inner : 0   
                                                                    }) );            
            }


            improvedLayouts.push( new models.ThemeLayout({components : components}) );
        }
        
       
        return improvedLayouts;
    }

    _removeDuplicateRectangles(rectangles) 
    {
        const uniqueRectangles = [];
        const seenRectangles = new Set();
    
        rectangles.forEach(rect => {
            const key = `${rect.x}|${rect.y}|${rect.width}|${rect.height}`;
            if (!seenRectangles.has(key)) {
                seenRectangles.add(key);
                uniqueRectangles.push(rect);
            }
        });
    
        return uniqueRectangles;
    }

    _calculateTotalArea(rectangles) {
        if (rectangles.length === 0) {
            return 0; // No rectangles to process
        }
    
        // Collect all unique x-coordinates (edges of rectangles along the x-axis)
        const xEvents = [];
        rectangles.forEach(rect => {
            xEvents.push({ x: rect.x, type: 'start', rect });
            xEvents.push({ x: rect.x + rect.width, type: 'end', rect });
        });
    
        // Sort the x-events based on x-coordinate
        xEvents.sort((a, b) => a.x - b.x || (a.type === 'start' ? -1 : 1));
    
        let totalArea = 0;
        let activeRectangles = [];
    
        // Process intervals between x-events
        for (let i = 0; i < xEvents.length - 1; i++) {
            const currentX = xEvents[i].x;
            const nextX = xEvents[i + 1].x;
            const deltaX = nextX - currentX;
    
            // Update active rectangles
            if (xEvents[i].type === 'start') {
                activeRectangles.push(xEvents[i].rect);
            } else {
                activeRectangles = activeRectangles.filter(
                    rect => rect !== xEvents[i].rect
                );
            }
    
            if (deltaX === 0 || activeRectangles.length === 0) continue; // No width or no active rectangles to process
    
            // Collect all y-intervals from active rectangles
            const yIntervals = activeRectangles.map(rect => [rect.y, rect.y + rect.height]);
    
            // Merge overlapping y-intervals
            yIntervals.sort((a, b) => a[0] - b[0]);
            const mergedYIntervals = [];
            let [startY, endY] = yIntervals[0];
    
            for (let j = 1; j < yIntervals.length; j++) {
                const [currentStartY, currentEndY] = yIntervals[j];
                if (currentStartY <= endY) {
                    // Overlapping intervals, merge them
                    endY = Math.max(endY, currentEndY);
                } else {
                    // Non-overlapping interval, add the previous one
                    mergedYIntervals.push([startY, endY]);
                    [startY, endY] = yIntervals[j];
                }
            }
            // Add the last interval
            mergedYIntervals.push([startY, endY]);
    
            // Calculate total height covered in this x-interval
            let deltaY = 0;
            mergedYIntervals.forEach(interval => {
                deltaY += interval[1] - interval[0];
            });
    
            // Add area of this x-interval to total area
            totalArea += deltaX * deltaY;
        }
    
        return totalArea;
    }
    
    _calculateBoundingBox(rectangles) {
        if (rectangles.length === 0) {
            return null; // No rectangles to process
        }
    
        // Initialize the bounding box with the first rectangle's properties
        let left = rectangles[0].x;
        let top = rectangles[0].y;
        let right = rectangles[0].x + rectangles[0].width;
        let bottom = rectangles[0].y + rectangles[0].height;
    
        // Loop through each rectangle to find the extreme coordinates
        for (let i = 1; i < rectangles.length; i++) {
            const rect = rectangles[i];
            left = Math.min(left, rect.x);
            top = Math.min(top, rect.y);
            right = Math.max(right, rect.x + rect.width);
            bottom = Math.max(bottom, rect.y + rect.height);
        }
    
        // Return the bounding box as a new rectangle object
        return {
            x: left,
            y: top,
            width: right - left,
            height: bottom - top
        };
    }

    _getAllCombinations(n)
    {
        let array = [];
        for (let i = 0; i < n; i++)
            array.push(this._moves);
        
        return this. _combine(array);
    }

    _combine(arraysToCombine)
    {
        const divisors = [];
        let combinationsCount = 1;
        for (let i = arraysToCombine.length - 1; i >= 0; i--) {
            divisors[i] = divisors[i + 1] ? divisors[i + 1] * arraysToCombine[i + 1].length : 1;
            combinationsCount *= (arraysToCombine[i].length || 1);
        }
      
        const getCombination = (n, arrays, divisors) => arrays.reduce((acc, arr, i) => {
            acc.push(arr[Math.floor(n / divisors[i]) % arr.length]);
            return acc;
        }, []);
      
        const combinations = [];
        for (let i = 0; i < combinationsCount; i++) {
            combinations.push(getCombination(i, arraysToCombine, divisors));
        }
        return combinations;
      }


      _countIntersectingRectangles(rectangles) {
        const n = rectangles.length;
        const intersectingRectangles = new Set();
    
        for (let i = 0; i < n; i++) {
            const rect1 = rectangles[i];
            for (let j = i + 1; j < n; j++) {
                const rect2 = rectangles[j];
                let intersect = !(
                    rect1.x + rect1.width <= rect2.x ||
                    rect2.x + rect2.width <= rect1.x ||
                    rect1.y + rect1.height <= rect2.y ||
                    rect2.y + rect2.height <= rect1.y
                )
                if (intersect) {
                    intersectingRectangles.add(i);
                    intersectingRectangles.add(j);
                }
            }
        }
        return intersectingRectangles.size;
    }
    
    _getAllPermutationsHeap(objects) {
        const permutations = [];
        const n = objects.length;
    
        function generate(n, arr) {
            if (n === 1) {
                permutations.push([...arr]);
            } else {
                for (let i = 0; i < n; i++) {
                    generate(n - 1, arr);
    
                    const j = n % 2 === 0 ? i : 0;
                    [arr[n - 1], arr[j]] = [arr[j], arr[n - 1]]; // Swap
                }
            }
        }
    
        generate(n, objects.slice());
        return permutations;
    }

    // -------------------------------------------------------------- //

   
    
    
});